import ModalDialogMotionEditForm from '../../../../modalDialogEditarMovimiento/ModalDialogMotionEditForm'

const ModalGroupClassificationEdit = ({
  open,
  setOpen,
  idLibro,
  status,
  setSwitchGetData,
  groupTitle,
  groupLabel,
  type = 'venta',
  centroCostoLibroIds = [],
  summary,
  reemplazar = true
}) => {
  const contextLabel = [groupTitle, groupLabel].filter(Boolean).join(' ')

  return (
    <ModalDialogMotionEditForm
      title='Editar clasificacion'
      open={open}
      setOpen={setOpen}
      idLibro={idLibro}
      status={status}
      type={type}
      setSwitchGetData={setSwitchGetData}
      hideMovementSummary={true}
      contextLabel={contextLabel}
      modalSize='large'
      modalWidth={1200}
      modalHeight={680}
      bulkCentroCostoLibroIds={centroCostoLibroIds}
      bulkCentroCostoReemplazar={reemplazar}
      movementSummary={summary}
    />
  )
}

export default ModalGroupClassificationEdit
